export default {
  state: {
    showTooltip: localStorage.getItem('show-tooltip') || ''
  },
  getters: {
    showTooltip: (state) => {
      return state.showTooltip;
    }
  },
  mutations: {
    tooltip: (state, bool) => {
      state.showTooltip = bool;
      localStorage.setItem('show-tooltip', bool);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/tooltips.js